import React from "react";
import {
    UserOutlined,
    MailOutlined,
    CalendarOutlined,
    BankOutlined,
    DollarOutlined,
    InfoCircleOutlined,
    FileTextOutlined
} from "@ant-design/icons";
import { Col, Row } from "antd";
import CommonCard from "../../../../global/card";
import { cn } from "../../../../../utils/cn";
import { formatDateTime } from "../../../../../utils/functions";

const EnhancedPaymentHistoryDetails = ({
    paymentDetail,
}) => {
    if (!paymentDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Customer Name": <UserOutlined />,
            "Customer Email": <MailOutlined />,
            "Payment At": <CalendarOutlined />,
            "Payment Gateway": <BankOutlined />,
            "Amount": <DollarOutlined />,
            "Description": <FileTextOutlined />
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard>
                <Row gutter={[48, 24]}>
                    {/* Transaction Details */}
                    <Col span={12} className="border-r border-gray-100">
                        <div className="flex items-center gap-2 mb-6">
                            <DollarOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                            <span style={{ fontSize: "16px", fontWeight: 600 }}>Transaction Details</span>
                        </div>
                        {[
                            { label: "Amount", value: `$${paymentDetail?.amount}` },
                            { label: "Payment Gateway", value: paymentDetail?.paymentGateway },
                            { label: "Payment At", value: formatDateTime(paymentDetail?.createdAt) },
                        ].map((item, idx) => (
                            <div key={item.label} className={cn("flex justify-between items-center w-full py-4 border-b border-gray-100", idx === 2 && "!border-b-0")}>
                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                    <span style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }}>
                                        {getIconForField(item.label)}
                                    </span>
                                    {item.label}
                                </span>
                                <span className="text-sm font-semibold text-gray-900">{item.value || "—"}</span>
                            </div>
                        ))}
                    </Col>

                    {/* Customer Details */}
                    <Col span={12} className="pl-6">
                        <div className="flex items-center gap-2 mb-6">
                            <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                            <span style={{ fontSize: "16px", fontWeight: 600 }}>Customer Details</span>
                        </div>
                        {[
                            { label: "Customer Name", value: paymentDetail?.User?.name || "N/A" },
                            { label: "Customer Email", value: paymentDetail?.userEmail },
                        ].map((item, idx) => (
                            <div key={item.label} className={cn("flex justify-between items-center w-full py-4 border-b border-gray-100", idx === 1 && "!border-b-0")}>
                                <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                    <span style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }}>
                                        {getIconForField(item.label)}
                                    </span>
                                    {item.label}
                                </span>
                                <span className="text-sm font-semibold text-gray-900">{item.value || "—"}</span>
                            </div>
                        ))}
                    </Col>

                    {/* Description */}
                    {paymentDetail?.description && (
                        <Col span={24} className="mt-6 pt-6 border-t border-gray-100">
                            <div className="flex items-center gap-2 mb-3">
                                <FileTextOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>Description</span>
                            </div>
                            <p className="text-gray-700 leading-relaxed">{paymentDetail.description}</p>
                        </Col>
                    )}
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedPaymentHistoryDetails;
